import React from 'react';
import { Heading } from '@landr/maestro';
import { Environment, Languages, PricingProvider } from '@landr/pricing';
import { Edges, PageContextType } from 'types';
import { graphql, StaticQuery } from 'gatsby';
import { getTwoLetterLanguageCode } from 'helpers';
import { ApplicationEnum } from '@landr/core.models';
import { getCheckoutLinkFromPlanCode } from 'helpers/pricingLinkUtils';
import { log } from '../../../log';
import { SliceContext } from '../types';
import { SupportedPrismicSlicesEnum } from '../enums';
import { CommonPricingTranslations, PricingTabDocument } from './types';
import { PricingTabs, Tabs } from './components/PricingTabs';
import { StyledPricingContentBox } from './styled';

const logger = log.getInstance('PricingTab');

export type PricingTableDocument = CommonPricingTranslations & {
    tabs: Tabs;
};

export type PricingSliceProps = {
    sliceContext: SliceContext;
    pageContext: PageContextType;
    location: Location;
    slice: {
        type: SupportedPrismicSlicesEnum.pricing;
        primary: {
            pricing_table: PricingTableDocument;
            pricing_title: string;
        };
    };
};

const PricingQuery = graphql`
    {
        allPrismicPricingTabsJson {
            edges {
                node {
                    ...PrismicPricingTabsJsonFragment
                }
            }
        }
    }
`;

export const Pricing = ({ sliceContext, pageContext, location, slice }: PricingSliceProps) => {
    const handleSubscriptionPurchase = (code: string, frequency: string, couponCode?: string) => {
        window.open(getCheckoutLinkFromPlanCode(code, frequency, couponCode), '_blank');
    };
    return (
        <StaticQuery
            // 'allPrismicPricingTabsJson' query is created by gatsy-transformer-json which used the data in the src/data
            query={`${PricingQuery}`}
            render={({
                allPrismicPricingTabsJson: pricingTabsData,
            }: {
                allPrismicPricingTabsJson: Edges<PricingTabDocument>;
            }) => {
                const { pricing_table, pricing_title } = slice.primary;
                const { tabs: pricingTabs, ...translations } = pricing_table;

                return (
                    <PricingProvider
                        applicationName={ApplicationEnum.GuestSite}
                        env={process.env.GATSBY_ENV as Environment}
                        language={getTwoLetterLanguageCode(pageContext.lang) as Languages}
                        log={logger}
                        locationPathname={location.pathname}
                        onSubscriptionPurchase={handleSubscriptionPurchase}
                    >
                        <StyledPricingContentBox>
                            <Heading as="h1" size="jb">
                                {pricing_title}
                            </Heading>
                            <PricingTabs
                                pricingTabs={pricingTabs}
                                pricingTabsData={pricingTabsData}
                                translations={translations}
                                sliceContext={sliceContext}
                                pageContext={pageContext}
                                location={location}
                            />
                        </StyledPricingContentBox>
                    </PricingProvider>
                );
            }}
        />
    );
};
